import APIConnector from "../lib/APIConnector";
import Settings from '../base/Settings'
const apiConnector = new APIConnector({ timeout: 30000 })
const apiConnectorLarge = new APIConnector({ timeout: 120000 })

export default class EventConfig {
  static get endpoint(){
    return Settings.SERVICE_DOMAIN
  }
  static get endpoint_v2(){
    return Settings.SERVICE_DOMAIN_V2
  }
  static get endpointEvents() {
    return `${EventConfig.endpoint}/events`;
  }
  static get endpointTransfer() {
    return `${EventConfig.endpoint}/payment/mpago/transfer-ticket-document`;
  }
  static get endpointSaveEvent() {
    return `${EventConfig.endpointEvents}/save`;
  }
  static get endpointDeleteEvent() {
    return `${EventConfig.endpointEvents}/delete`;
  }
  static get endpointTicketTypes() {
    return `${EventConfig.endpointEvents}/ticketTypes`;
  }
  static get endpointSaveTicketType() {
    return `${EventConfig.endpointTicketTypes}/save`;
  }
  static get endpointDeleteTicketType() {
    return `${EventConfig.endpointTicketTypes}/delete`;
  }
  static get endpointCategories() {
    return `${EventConfig.endpointTicketTypes}/categories`;
  }
  static get endpointTickets() {
    return `${EventConfig.endpointEvents}/tickets`;
  }
  static get endpointSaveTickets() {
    // return `${EventConfig.endpointTickets}/save`;
    return `${EventConfig.endpoint_v2}/events/tickets/save`
  }
  static get endpointDeleteTicket() {
    return `${EventConfig.endpointTickets}/delete`;
  }
  static get endpointDeleteTicket() {
    return `${EventConfig.endpointTickets}/delete`;
  }
  static get endpointStatistics() {
    return `${EventConfig.endpointEvents}/statistics`;
  }
  //Deprecada
  // static get endpointStatisticsRRPP() {
  //   return `${EventConfig.endpointEvents}/rrpp`;
  // }
  static get endpointStatisticsDirectRRPP() {
    return `${EventConfig.endpointEvents}/detail-direct-rrpp`;
  }
  static get endpointStatisticsReferencedRRPP() {
    return `${EventConfig.endpointEvents}/detail-referenced-rrpp`;
  }
  static get endpointStatisticsProducer() {
    return `${EventConfig.endpointEvents}/detail-producer`;
  }
  static get APIConnector() {
    return apiConnector
  }
  static get APIConnectorLarge() {
    return apiConnectorLarge
  }
}



// WEBPACK FOOTER //
// ./src/provider/event/EventConfig.js